import qrcode from 'qrcode-generator';

/**
 * Generates a Data URL (base64) for a QR code with the given data.
 * Works locally without external network requests.
 * @param data The string to encode in the QR code.
 * @param cellSize The size of each QR module (pixel).
 * @param margin The margin around the QR code.
 */
export const generateLocalQrCode = (data: string, cellSize: number = 4, margin: number = 1): string => {
  try {
    const qr = qrcode(0, 'M');
    qr.addData(data);
    qr.make();
    return qr.createDataURL(cellSize, margin);
  } catch (error) {
    console.error('Error generating local QR code:', error);
    return '';
  }
};
